import { Component, Inject } from '@angular/core'
import { FormsModule } from '@angular/forms'
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog'
import { MatButtonModule } from '@angular/material/button'
import { MatIconModule } from '@angular/material/icon'
import { MatInputModule } from '@angular/material/input'
import { MatFormFieldModule } from '@angular/material/form-field'
import { MatTooltipModule } from '@angular/material/tooltip'
import { CurrencyPipe } from '@angular/common'

export interface ServicoAdicionalItem {
  servicoAdicionalId: number
  descricao: string
  quantidade: number
  taxa: number
  valorUnitario: number
  valorTotal: number
  observacao?: string | null
}

interface CatalogoEntry {
  id: number
  descricao: string
  taxa: number
  valorUnitario: number
}

@Component({
  selector: 'modal-group-additional-service',
  standalone: true,
  imports: [
    FormsModule,
    MatButtonModule,
    MatIconModule,
    MatInputModule,
    MatFormFieldModule,
    MatTooltipModule,
    CurrencyPipe,
  ],
  template: `
    <div class="dialog-container">
      <div class="dialog-header">
        <span class="dialog-title">Serviços Adicionais</span>
        <button class="btn-icon" (click)="close()"><mat-icon>close</mat-icon></button>
      </div>

      <div class="catalogo-list">
        @for (item of catalogo; track item.id) {
          <div class="catalogo-row" [class.selecionado]="isSelected(item)">
            <div class="catalogo-info">
              <span class="catalogo-desc">{{ item.descricao }}</span>
              <span class="catalogo-valor">{{ item.valorUnitario | currency:'BRL':'symbol':'1.2-2' }}</span>
            </div>
            @if (isSelected(item)) {
              <div class="catalogo-controls">
                <div class="catalogo-qty-row">
                  <button class="qty-btn" (click)="decQtd(item)">
                    <mat-icon>remove</mat-icon>
                  </button>
                  <span class="qty-value">{{ getQtd(item) }}</span>
                  <button class="qty-btn" (click)="incQtd(item)">
                    <mat-icon>add</mat-icon>
                  </button>
                  <span class="qty-sep"></span>
                  <span class="taxa-label">Taxa %</span>
                  <input class="taxa-input" type="number" min="0" max="100"
                    [value]="getTaxa(item)"
                    (change)="setTaxa(item, $any($event.target).value)" />
                </div>
                <div class="catalogo-valores">
                  <span class="valor-item">
                    <span class="valor-label">Unitário</span>
                    <span class="valor-num">{{ item.valorUnitario | currency:'BRL':'symbol':'1.2-2' }}</span>
                  </span>
                  <span class="valor-sep">×{{ getQtd(item) }}</span>
                  <span class="valor-item valor-total">
                    <span class="valor-label">Total</span>
                    <span class="valor-num">{{ getTotal(item) | currency:'BRL':'symbol':'1.2-2' }}</span>
                  </span>
                </div>
                <input class="observacao-input" type="text" placeholder="Observação (opcional)"
                  [value]="getObservacao(item)"
                  (change)="setObservacao(item, $any($event.target).value)" />
              </div>
            } @else {
              <button mat-button class="btn-tg btn-add-srv" (click)="adicionar(item)">
                <mat-icon>add</mat-icon> Adicionar
              </button>
            }
          </div>
        }
      </div>

      <div class="dialog-footer">
        <button mat-button class="btn-tg-white" (click)="close()">Cancelar</button>
        <button mat-button class="btn-tg" (click)="confirm()">Confirmar</button>
      </div>
    </div>
  `,
  styles: [`
    .dialog-container { display: flex; flex-direction: column; min-width: 420px; max-height: 70vh; }
    .dialog-header { display: flex; align-items: center; justify-content: space-between; padding: 12px 16px; border-bottom: 1px solid #dbdbdb; }
    .dialog-title { font-weight: 600; font-size: 15px; color: #1e1e1e; }
    .catalogo-list { flex: 1; overflow-y: auto; }
    .catalogo-row {
      display: flex; align-items: center; justify-content: space-between;
      padding: 10px 16px; border-bottom: 1px solid #f1f1f1; gap: 12px;
    }
    .catalogo-row.selecionado { background: #fff7ed; }
    .catalogo-info { display: flex; flex-direction: column; gap: 2px; flex: 1; min-width: 0; }
    .catalogo-desc { font-size: 13px; font-weight: 500; color: #1e1e1e; }
    .catalogo-valor { font-size: 12px; color: #707070; }
    .catalogo-qty-row {
      display: flex; align-items: center; gap: 0;
      border: 1px solid #dbdbdb; border-radius: 6px; overflow: hidden; flex-shrink: 0;
    }
    .qty-btn {
      display: flex; align-items: center; justify-content: center;
      width: 32px; height: 32px; background: #f1f1f1; border: none;
      cursor: pointer; color: #1e1e1e; flex-shrink: 0;
      &:hover { background: #f3d3c1; color: #9b4716; }
      mat-icon { font-size: 18px; width: 18px; height: 18px; }
    }
    .qty-value {
      font-size: 13px; font-weight: 600; color: #1e1e1e;
      min-width: 32px; text-align: center; padding: 0 4px; line-height: 32px;
      background: #fff;
    }
    .btn-add-srv { font-size: 12px; flex-shrink: 0; }
    .catalogo-controls { display: flex; flex-direction: column; gap: 6px; align-items: flex-end; flex-shrink: 0; }
    .qty-sep { width: 1px; height: 24px; background: #dbdbdb; margin: 0 6px; flex-shrink: 0; }
    .taxa-label { font-size: 11px; color: #707070; white-space: nowrap; flex-shrink: 0; }
    .taxa-input {
      width: 52px; height: 32px; border: 1px solid #dbdbdb; border-radius: 4px;
      text-align: center; font-size: 13px; padding: 0 4px;
      outline: none; flex-shrink: 0;
      &:focus { border-color: #ea6218; }
    }
    .catalogo-valores {
      display: flex; align-items: center; gap: 8px;
      font-size: 12px; color: #707070;
    }
    .valor-item { display: flex; flex-direction: column; align-items: flex-end; gap: 1px; }
    .valor-label { font-size: 10px; text-transform: uppercase; letter-spacing: 0.04em; color: #707070; }
    .valor-num { font-size: 13px; font-weight: 600; color: #1e1e1e; }
    .valor-sep { font-size: 12px; color: #707070; padding: 0 2px; }
    .valor-total .valor-num { color: #9b4716; }
    .observacao-input {
      width: 100%; margin-top: 6px; box-sizing: border-box;
      border: 1px solid #dbdbdb; border-radius: 4px;
      font-size: 12px; padding: 6px 8px; outline: none;
      &:focus { border-color: #ea6218; }
    }
    .dialog-footer { display: flex; justify-content: flex-end; gap: 8px; padding: 12px 16px; border-top: 1px solid #dbdbdb; }
  `],
})
export class ModalGroupAdditionalServiceComponent {
  catalogo: CatalogoEntry[]
  selecionados: ServicoAdicionalItem[]

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: { catalogo: CatalogoEntry[]; selecionados: ServicoAdicionalItem[] },
    private dialogRef: MatDialogRef<ModalGroupAdditionalServiceComponent>,
  ) {
    this.catalogo = data.catalogo ?? []
    this.selecionados = data.selecionados.map(s => ({ ...s }))
  }

  isSelected(item: CatalogoEntry): boolean {
    return this.selecionados.some(s => s.servicoAdicionalId === item.id)
  }

  getQtd(item: CatalogoEntry): number {
    return this.selecionados.find(s => s.servicoAdicionalId === item.id)?.quantidade ?? 1
  }

  adicionar(item: CatalogoEntry): void {
    this.selecionados = [
      ...this.selecionados,
      {
        servicoAdicionalId: item.id,
        descricao: item.descricao,
        quantidade: 1,
        taxa: item.taxa ?? 0,
        valorUnitario: item.valorUnitario,
        valorTotal: item.valorUnitario,
        observacao: '',
      },
    ]
  }

  getObservacao(item: CatalogoEntry): string {
    return this.selecionados.find(s => s.servicoAdicionalId === item.id)?.observacao ?? ''
  }

  setObservacao(item: CatalogoEntry, value: string): void {
    this.selecionados = this.selecionados.map(s =>
      s.servicoAdicionalId === item.id ? { ...s, observacao: value } : s,
    )
  }

  remover(item: CatalogoEntry): void {
    this.selecionados = this.selecionados.filter(s => s.servicoAdicionalId !== item.id)
  }

  getTotal(item: CatalogoEntry): number {
    const srv = this.selecionados.find(s => s.servicoAdicionalId === item.id)
    if (!srv) return 0
    const base = srv.valorUnitario * srv.quantidade
    return srv.taxa > 0 ? +(base * (1 + srv.taxa / 100)).toFixed(2) : base
  }

  getTaxa(item: CatalogoEntry): number {
    return this.selecionados.find(s => s.servicoAdicionalId === item.id)?.taxa ?? 0
  }

  setTaxa(item: CatalogoEntry, value: string): void {
    const taxa = parseFloat(value) || 0
    this.selecionados = this.selecionados.map(s => {
      if (s.servicoAdicionalId !== item.id) return s
      const base = s.valorUnitario * s.quantidade
      return { ...s, taxa, valorTotal: taxa > 0 ? +(base * (1 + taxa / 100)).toFixed(2) : base }
    })
  }

  incQtd(item: CatalogoEntry): void {
    this.selecionados = this.selecionados.map(s => {
      if (s.servicoAdicionalId !== item.id) return s
      const qtd = s.quantidade + 1
      const base = s.valorUnitario * qtd
      return { ...s, quantidade: qtd, valorTotal: s.taxa > 0 ? +(base * (1 + s.taxa / 100)).toFixed(2) : base }
    })
  }

  decQtd(item: CatalogoEntry): void {
    const srv = this.selecionados.find(s => s.servicoAdicionalId === item.id)
    if (!srv) return
    if (srv.quantidade <= 1) {
      this.remover(item)
      return
    }
    this.selecionados = this.selecionados.map(s => {
      if (s.servicoAdicionalId !== item.id) return s
      const qtd = s.quantidade - 1
      return { ...s, quantidade: qtd, valorTotal: +(s.valorUnitario * qtd).toFixed(2) }
    })
  }

  confirm(): void {
    this.dialogRef.close(this.selecionados)
  }

  close(): void {
    this.dialogRef.close(null)
  }
}
